import * as React from "react";

const ArrowLeft: React.FC = () => {
    return <svg width="16px" height="14px" viewBox="0 0 16 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-270.000000, -360.000000)" fill="CurrentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(191.000000, 130.000000)">
                    <polygon points="3.4 8 16 8 16 6 3.3 6 8.3 1.3 7 0 0 7 7 14 8.3 12.7"></polygon>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(ArrowLeft);
